import React from 'react';
import Stack, { FormStack, contentStackSpacing } from '../../../v2BaseComponents/Stack';
import { colors } from '../../../../utils/theme';
import Text from '../../../v2BaseComponents/Text';
import IconButton from '../../../v2BaseComponents/IconButton';

export type FormInputSectionOwnProps = {
    children: React.ReactNode;
    title: string;
    removeTestID: string;
    onRemove: () => void;
    isDisabled: boolean;
};

export type FormInputSectionProps = FormInputSectionOwnProps;

const FormInputSection: React.FC<FormInputSectionProps> = (props) => {
    return (
        <Stack vertical fullWidth style={{ backgroundColor: colors.Background, borderRadius: 8 }} padding={4} space={2}>
            <Stack horizontal fullWidth justify="space-between" align={'center'} space={contentStackSpacing}>
                <Text variant="body-1">{props.title}</Text>
                <IconButton
                    onPress={props.onRemove}
                    variant="transparent"
                    icon="X"
                    isDisabled={props.isDisabled}
                    testID={props.removeTestID}
                />
            </Stack>
            <FormStack>{props.children}</FormStack>
        </Stack>
    );
};

export default React.memo(FormInputSection);
